/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '../../../src/app/app.module';
import * as import2 from '@angular/common/src/common_module';
import * as import3 from '@angular/core/src/application_module';
import * as import4 from '@angular/platform-browser/src/browser';
import * as import5 from '@angular/http/src/http_module';
import * as import6 from 'ng2-translate/index';
import * as import7 from '../../../src/app/shared/shared.module';
import * as import8 from '@angular/forms/src/directives';
import * as import9 from '@angular/forms/src/form_providers';
import * as import10 from 'angular2-text-mask/dist/angular2TextMask';
import * as import11 from '../../../src/app/search-panel/search-panel.module';
import * as import12 from '../../../src/app/document-hitlist/document-hitlist.module';
import * as import13 from '../../../src/app/language-selector/language-selector.module';
import * as import14 from '@angular/common/src/localization';
import * as import15 from '@angular/http/src/backends/browser_xhr';
import * as import16 from '@angular/http/src/base_response_options';
import * as import17 from '@angular/http/src/backends/xhr_backend';
import * as import18 from '@angular/http/src/base_request_options';
import * as import19 from '../../../src/app/shared/services/config.service';
import * as import20 from '../../../src/app/shared/i18n/bundled-translate-loader';
import * as import21 from 'ng2-translate/src/translate.parser';
import * as import22 from 'ng2-translate/src/translate.service';
import * as import23 from '@angular/core/src/application_init';
import * as import24 from '@angular/core/src/testability/testability';
import * as import25 from '@angular/core/src/application_ref';
import * as import26 from '@angular/core/src/linker/compiler';
import * as import27 from '@angular/platform-browser/src/dom/events/hammer_gestures';
import * as import28 from '@angular/platform-browser/src/dom/events/event_manager';
import * as import29 from '@angular/platform-browser/src/dom/shared_styles_host';
import * as import30 from '@angular/platform-browser/src/dom/dom_renderer';
import * as import31 from '@angular/platform-browser/src/security/dom_sanitization_service';
import * as import32 from '@angular/core/src/animation/animation_queue';
import * as import33 from '@angular/core/src/linker/view_utils';
import * as import34 from '@angular/platform-browser/src/browser/title';
import * as import35 from '@angular/forms/src/directives/radio_control_value_accessor';
import * as import36 from '@angular/forms/src/form_builder';
import * as import37 from '../../../src/app/shared/services/api.service';
import * as import38 from '../../../src/app/shared/services/messenger.service';
import * as import39 from '../../../src/app/shared/services/query-string.service';
import * as import40 from '@angular/core/src/di/injector';
import * as import41 from './search-panel/components/search-panel.component.ngfactory';
import * as import42 from './search-panel/components/fulltext-search-panel.component.ngfactory';
import * as import43 from './document-hitlist/components/document-hitlist.component.ngfactory';
import * as import44 from './language-selector/components/language-selector.component.ngfactory';
import * as import45 from '@angular/core/src/i18n/tokens';
import * as import46 from '@angular/core/src/application_tokens';
import * as import47 from '@angular/platform-browser/src/dom/events/dom_events';
import * as import48 from '@angular/platform-browser/src/dom/events/key_events';
import * as import49 from '@angular/core/src/zone/ng_zone';
import * as import50 from '@angular/platform-browser/src/dom/debug/ng_probe';
import * as import51 from '@angular/core/src/console';
import * as import52 from '@angular/core/src/error_handler';
import * as import53 from '@angular/http/src/interfaces';
import * as import54 from '@angular/http/src/http';
import * as import55 from '@angular/platform-browser/src/dom/dom_tokens';
import * as import56 from '@angular/platform-browser/src/dom/animation_driver';
import * as import57 from '@angular/core/src/render/api';
import * as import58 from '@angular/core/src/security';
import * as import59 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import60 from '@angular/core/src/change_detection/differs/keyvalue_differs';
class AppModuleInjector extends import0.NgModuleInjector<import1.AppModule> {
  _CommonModule_0:import2.CommonModule;
  _ApplicationModule_1:import3.ApplicationModule;
  _BrowserModule_2:import4.BrowserModule;
  _HttpModule_3:import5.HttpModule;
  _TranslateModule_4:import6.TranslateModule;
  _SharedModule_5:import7.SharedModule;
  _InternalFormsSharedModule_6:import8.InternalFormsSharedModule;
  _FormsModule_7:import9.FormsModule;
  _ReactiveFormsModule_8:import9.ReactiveFormsModule;
  _TextMaskModule_9:import10.TextMaskModule;
  _SearchPanelModule_10:import11.SearchPanelModule;
  _DocumentHitlistModule_11:import12.DocumentHitlistModule;
  _LanguageSelectorModule_12:import13.LanguageSelectorModule;
  _AppModule_13:import1.AppModule;
  __LOCALE_ID_14:any;
  __NgLocalization_15:import14.NgLocaleLocalization;
  _ErrorHandler_16:any;
  _BrowserXhr_17:import15.BrowserXhr;
  _ResponseOptions_18:import16.BaseResponseOptions;
  _XSRFStrategy_19:any;
  _XHRBackend_20:import17.XHRBackend;
  _RequestOptions_21:import18.BaseRequestOptions;
  _Http_22:any;
  _ConfigService_23:import19.ConfigService;
  _TranslateLoader_24:import20.BundledTranslateLoader;
  _TranslateParser_25:import21.DefaultTranslateParser;
  _TranslateService_26:import22.TranslateService;
  _APP_INITIALIZER_27:any[];
  _ApplicationInitStatus_28:import23.ApplicationInitStatus;
  _Testability_29:import24.Testability;
  _ApplicationRef__30:import25.ApplicationRef_;
  __ApplicationRef_31:any;
  __Compiler_32:import26.Compiler;
  __APP_ID_33:any;
  __DOCUMENT_34:any;
  __HAMMER_GESTURE_CONFIG_35:import27.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_36:any[];
  __EventManager_37:import28.EventManager;
  _DomSharedStylesHost_38:import29.DomSharedStylesHost;
  __AnimationDriver_39:any;
  __DomRootRenderer_40:import30.DomRootRenderer_;
  __RootRenderer_41:any;
  __DomSanitizer_42:import31.DomSanitizerImpl;
  __Sanitizer_43:any;
  __AnimationQueue_44:import32.AnimationQueue;
  __ViewUtils_45:import33.ViewUtils;
  __IterableDiffers_46:any;
  __KeyValueDiffers_47:any;
  __SharedStylesHost_48:any;
  __Title_49:import34.Title;
  __RadioControlRegistry_50:import35.RadioControlRegistry;
  __FormBuilder_51:import36.FormBuilder;
  __ApiService_52:import37.ApiService;
  __MessengerService_53:import38.MessengerService;
  __QueryStringService_54:import39.QueryStringService;
  constructor(parent:import40.Injector) {
    super(parent,[
      import41.SearchPanelComponentNgFactory,
      import42.FulltextSearchPanelComponentNgFactory,
      import43.DocumentHitlistComponentNgFactory,
      import44.LanguageSelectorComponentNgFactory
    ]
    ,([] as any[]));
  }
  get _LOCALE_ID_14():any {
    if ((this.__LOCALE_ID_14 == null)) { (this.__LOCALE_ID_14 = import3._localeFactory(this.parent.get(import45.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_14;
  }
  get _NgLocalization_15():import14.NgLocaleLocalization {
    if ((this.__NgLocalization_15 == null)) { (this.__NgLocalization_15 = new import14.NgLocaleLocalization(this._LOCALE_ID_14)); }
    return this.__NgLocalization_15;
  }
  get _ApplicationRef_31():any {
    if ((this.__ApplicationRef_31 == null)) { (this.__ApplicationRef_31 = this._ApplicationRef__30); }
    return this.__ApplicationRef_31;
  }
  get _Compiler_32():import26.Compiler {
    if ((this.__Compiler_32 == null)) { (this.__Compiler_32 = new import26.Compiler()); }
    return this.__Compiler_32;
  }
  get _APP_ID_33():any {
    if ((this.__APP_ID_33 == null)) { (this.__APP_ID_33 = import46._appIdRandomProviderFactory()); }
    return this.__APP_ID_33;
  }
  get _DOCUMENT_34():any {
    if ((this.__DOCUMENT_34 == null)) { (this.__DOCUMENT_34 = import4._document()); }
    return this.__DOCUMENT_34;
  }
  get _HAMMER_GESTURE_CONFIG_35():import27.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_35 == null)) { (this.__HAMMER_GESTURE_CONFIG_35 = new import27.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_35;
  }
  get _EVENT_MANAGER_PLUGINS_36():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_36 == null)) { (this.__EVENT_MANAGER_PLUGINS_36 = [
      new import47.DomEventsPlugin(),
      new import48.KeyEventsPlugin(),
      new import27.HammerGesturesPlugin(this._HAMMER_GESTURE_CONFIG_35)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_36;
  }
  get _EventManager_37():import28.EventManager {
    if ((this.__EventManager_37 == null)) { (this.__EventManager_37 = new import28.EventManager(this._EVENT_MANAGER_PLUGINS_36,this.parent.get(import49.NgZone))); }
    return this.__EventManager_37;
  }
  get _AnimationDriver_39():any {
    if ((this.__AnimationDriver_39 == null)) { (this.__AnimationDriver_39 = import4._resolveDefaultAnimationDriver()); }
    return this.__AnimationDriver_39;
  }
  get _DomRootRenderer_40():import30.DomRootRenderer_ {
    if ((this.__DomRootRenderer_40 == null)) { (this.__DomRootRenderer_40 = new import30.DomRootRenderer_(this._DOCUMENT_34,this._EventManager_37,this._DomSharedStylesHost_38,this._AnimationDriver_39,this._APP_ID_33)); }
    return this.__DomRootRenderer_40;
  }
  get _RootRenderer_41():any {
    if ((this.__RootRenderer_41 == null)) { (this.__RootRenderer_41 = import50._createConditionalRootRenderer(this._DomRootRenderer_40,this.parent.get(import50.NgProbeToken,(null as any)),this.parent.get(import25.NgProbeToken,(null as any)))); }
    return this.__RootRenderer_41;
  }
  get _DomSanitizer_42():import31.DomSanitizerImpl {
    if ((this.__DomSanitizer_42 == null)) { (this.__DomSanitizer_42 = new import31.DomSanitizerImpl()); }
    return this.__DomSanitizer_42;
  }
  get _Sanitizer_43():any {
    if ((this.__Sanitizer_43 == null)) { (this.__Sanitizer_43 = this._DomSanitizer_42); }
    return this.__Sanitizer_43;
  }
  get _AnimationQueue_44():import32.AnimationQueue {
    if ((this.__AnimationQueue_44 == null)) { (this.__AnimationQueue_44 = new import32.AnimationQueue(this.parent.get(import49.NgZone))); }
    return this.__AnimationQueue_44;
  }
  get _ViewUtils_45():import33.ViewUtils {
    if ((this.__ViewUtils_45 == null)) { (this.__ViewUtils_45 = new import33.ViewUtils(this._RootRenderer_41,this._Sanitizer_43,this._AnimationQueue_44)); }
    return this.__ViewUtils_45;
  }
  get _IterableDiffers_46():any {
    if ((this.__IterableDiffers_46 == null)) { (this.__IterableDiffers_46 = import3._iterableDiffersFactory()); }
    return this.__IterableDiffers_46;
  }
  get _KeyValueDiffers_47():any {
    if ((this.__KeyValueDiffers_47 == null)) { (this.__KeyValueDiffers_47 = import3._keyValueDiffersFactory()); }
    return this.__KeyValueDiffers_47;
  }
  get _SharedStylesHost_48():any {
    if ((this.__SharedStylesHost_48 == null)) { (this.__SharedStylesHost_48 = this._DomSharedStylesHost_38); }
    return this.__SharedStylesHost_48;
  }
  get _Title_49():import34.Title {
    if ((this.__Title_49 == null)) { (this.__Title_49 = new import34.Title()); }
    return this.__Title_49;
  }
  get _RadioControlRegistry_50():import35.RadioControlRegistry {
    if ((this.__RadioControlRegistry_50 == null)) { (this.__RadioControlRegistry_50 = new import35.RadioControlRegistry()); }
    return this.__RadioControlRegistry_50;
  }
  get _FormBuilder_51():import36.FormBuilder {
    if ((this.__FormBuilder_51 == null)) { (this.__FormBuilder_51 = new import36.FormBuilder()); }
    return this.__FormBuilder_51;
  }
  get _ApiService_52():import37.ApiService {
    if ((this.__ApiService_52 == null)) { (this.__ApiService_52 = new import37.ApiService(this._Http_22,this._ConfigService_23)); }
    return this.__ApiService_52;
  }
  get _MessengerService_53():import38.MessengerService {
    if ((this.__MessengerService_53 == null)) { (this.__MessengerService_53 = new import38.MessengerService()); }
    return this.__MessengerService_53;
  }
  get _QueryStringService_54():import39.QueryStringService {
    if ((this.__QueryStringService_54 == null)) { (this.__QueryStringService_54 = new import39.QueryStringService()); }
    return this.__QueryStringService_54;
  }
  createInternal():import1.AppModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ApplicationModule_1 = new import3.ApplicationModule();
    this._BrowserModule_2 = new import4.BrowserModule(this.parent.get(import4.BrowserModule,(null as any)));
    this._HttpModule_3 = new import5.HttpModule();
    this._TranslateModule_4 = new import6.TranslateModule();
    this._SharedModule_5 = new import7.SharedModule();
    this._InternalFormsSharedModule_6 = new import8.InternalFormsSharedModule();
    this._FormsModule_7 = new import9.FormsModule();
    this._ReactiveFormsModule_8 = new import9.ReactiveFormsModule();
    this._TextMaskModule_9 = new import10.TextMaskModule();
    this._SearchPanelModule_10 = new import11.SearchPanelModule();
    this._DocumentHitlistModule_11 = new import12.DocumentHitlistModule();
    this._LanguageSelectorModule_12 = new import13.LanguageSelectorModule();
    this._AppModule_13 = new import1.AppModule(this);
    this._ErrorHandler_16 = import4.errorHandler();
    this._BrowserXhr_17 = new import15.BrowserXhr();
    this._ResponseOptions_18 = new import16.BaseResponseOptions();
    this._XSRFStrategy_19 = import5._createDefaultCookieXSRFStrategy();
    this._XHRBackend_20 = new import17.XHRBackend(this._BrowserXhr_17,this._ResponseOptions_18,this._XSRFStrategy_19);
    this._RequestOptions_21 = new import18.BaseRequestOptions();
    this._Http_22 = import5.httpFactory(this._XHRBackend_20,this._RequestOptions_21);
    this._ConfigService_23 = new import19.ConfigService(this._Http_22);
    this._TranslateLoader_24 = new import20.BundledTranslateLoader();
    this._TranslateParser_25 = new import21.DefaultTranslateParser();
    this._TranslateService_26 = new import22.TranslateService(this._TranslateLoader_24,this._TranslateParser_25,this.parent.get(import22.MissingTranslationHandler,(null as any)));
    this._APP_INITIALIZER_27 = [import7.INIT_FACTORY(this._ConfigService_23,this._TranslateService_26)];
    this._ApplicationInitStatus_28 = new import23.ApplicationInitStatus(this._APP_INITIALIZER_27);
    this._Testability_29 = new import24.Testability(this.parent.get(import49.NgZone));
    this._ApplicationRef__30 = new import25.ApplicationRef_(this.parent.get(import49.NgZone),this.parent.get(import51.Console),this,this._ErrorHandler_16,this,this._ApplicationInitStatus_28,this.parent.get(import24.TestabilityRegistry,(null as any)),this._Testability_29);
    this._DomSharedStylesHost_38 = new import29.DomSharedStylesHost(this._DOCUMENT_34);
    return this._AppModule_13;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import3.ApplicationModule)) { return this._ApplicationModule_1; }
    if ((token === import4.BrowserModule)) { return this._BrowserModule_2; }
    if ((token === import5.HttpModule)) { return this._HttpModule_3; }
    if ((token === import6.TranslateModule)) { return this._TranslateModule_4; }
    if ((token === import7.SharedModule)) { return this._SharedModule_5; }
    if ((token === import8.InternalFormsSharedModule)) { return this._InternalFormsSharedModule_6; }
    if ((token === import9.FormsModule)) { return this._FormsModule_7; }
    if ((token === import9.ReactiveFormsModule)) { return this._ReactiveFormsModule_8; }
    if ((token === import10.TextMaskModule)) { return this._TextMaskModule_9; }
    if ((token === import11.SearchPanelModule)) { return this._SearchPanelModule_10; }
    if ((token === import12.DocumentHitlistModule)) { return this._DocumentHitlistModule_11; }
    if ((token === import13.LanguageSelectorModule)) { return this._LanguageSelectorModule_12; }
    if ((token === import1.AppModule)) { return this._AppModule_13; }
    if ((token === import45.LOCALE_ID)) { return this._LOCALE_ID_14; }
    if ((token === import14.NgLocalization)) { return this._NgLocalization_15; }
    if ((token === import52.ErrorHandler)) { return this._ErrorHandler_16; }
    if ((token === import15.BrowserXhr)) { return this._BrowserXhr_17; }
    if ((token === import16.ResponseOptions)) { return this._ResponseOptions_18; }
    if ((token === import53.XSRFStrategy)) { return this._XSRFStrategy_19; }
    if ((token === import17.XHRBackend)) { return this._XHRBackend_20; }
    if ((token === import18.RequestOptions)) { return this._RequestOptions_21; }
    if ((token === import54.Http)) { return this._Http_22; }
    if ((token === import19.ConfigService)) { return this._ConfigService_23; }
    if ((token === import22.TranslateLoader)) { return this._TranslateLoader_24; }
    if ((token === import21.TranslateParser)) { return this._TranslateParser_25; }
    if ((token === import22.TranslateService)) { return this._TranslateService_26; }
    if ((token === import23.APP_INITIALIZER)) { return this._APP_INITIALIZER_27; }
    if ((token === import23.ApplicationInitStatus)) { return this._ApplicationInitStatus_28; }
    if ((token === import24.Testability)) { return this._Testability_29; }
    if ((token === import25.ApplicationRef_)) { return this._ApplicationRef__30; }
    if ((token === import25.ApplicationRef)) { return this._ApplicationRef_31; }
    if ((token === import26.Compiler)) { return this._Compiler_32; }
    if ((token === import46.APP_ID)) { return this._APP_ID_33; }
    if ((token === import55.DOCUMENT)) { return this._DOCUMENT_34; }
    if ((token === import27.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_35; }
    if ((token === import28.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_36; }
    if ((token === import28.EventManager)) { return this._EventManager_37; }
    if ((token === import29.DomSharedStylesHost)) { return this._DomSharedStylesHost_38; }
    if ((token === import56.AnimationDriver)) { return this._AnimationDriver_39; }
    if ((token === import30.DomRootRenderer)) { return this._DomRootRenderer_40; }
    if ((token === import57.RootRenderer)) { return this._RootRenderer_41; }
    if ((token === import31.DomSanitizer)) { return this._DomSanitizer_42; }
    if ((token === import58.Sanitizer)) { return this._Sanitizer_43; }
    if ((token === import32.AnimationQueue)) { return this._AnimationQueue_44; }
    if ((token === import33.ViewUtils)) { return this._ViewUtils_45; }
    if ((token === import59.IterableDiffers)) { return this._IterableDiffers_46; }
    if ((token === import60.KeyValueDiffers)) { return this._KeyValueDiffers_47; }
    if ((token === import29.SharedStylesHost)) { return this._SharedStylesHost_48; }
    if ((token === import34.Title)) { return this._Title_49; }
    if ((token === import35.RadioControlRegistry)) { return this._RadioControlRegistry_50; }
    if ((token === import36.FormBuilder)) { return this._FormBuilder_51; }
    if ((token === import37.ApiService)) { return this._ApiService_52; }
    if ((token === import38.MessengerService)) { return this._MessengerService_53; }
    if ((token === import39.QueryStringService)) { return this._QueryStringService_54; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ApplicationRef__30.ngOnDestroy();
    this._DomSharedStylesHost_38.ngOnDestroy();
  }
}
export const AppModuleNgFactory:import0.NgModuleFactory<import1.AppModule> = new import0.NgModuleFactory(AppModuleInjector,import1.AppModule);


// WEBPACK FOOTER //
// ./$$_gendir/src/app/app.module.ngfactory.ts